<template>
  <div class="home-train-tab content-main">
    <div class="content-main__centered">
      <h4 class="appMain--text mb-2">Train</h4>
      <p class="mb-4">
        Develop your team's skills with targeted training programs.
      </p>

      <v-card class="pa-6 text-center">
        <v-icon size="48" color="grey lighten-1" class="mb-4">
          mdi-school-outline
        </v-icon>
        <h5 class="text-h6 mb-2">Training Tools</h5>
        <p class="text-body-2 grey--text">
          Create and deliver effective training content.
        </p>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeTrainTab',
};
</script>
